import {Component, Directive, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import { DatePipe } from '@angular/common';
import {NotificationsService} from 'angular2-notifications';
import {Location} from '@angular/common';
import {Incidence} from "../Incidence";
import {IncidenceService} from "../incidence.service";
import {I18NService} from "../../../../shared/i18n/i18n.service";
import {SergasDeviceService} from "../../device/SergasDevice.service";
import {SergasDevice} from "../../device/SergasDevice";
import {SergasDeviceValuelistService} from "../../device/SergasDeviceValuelist.service";

import { Subject } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { merge, of as observableOf } from 'rxjs';
import {empty} from "rxjs";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-incidence-detail',
  templateUrl: './incidence-detail.component.html',
  styleUrls: ['./incidence-detail.component.css']
})
export class IncidenceDetailComponent implements OnInit {

  isLoading = true;
  formFields: any;
  isNew = false;
  saving = false;

  incidence:Incidence | any = {};

  sergasDevices: SergasDevice[] = [];
  sergasDevicesMap = {};


  detailForm: FormGroup;

  dropdownList:any = [];
  selectedItems:any = [];
  deviceList:any[] = [];
  deviceMap:any[];
  dropdownSettings:any = {};
  isLoadingSergasDevices = true;

  notificationDropdownList:any = [];
  notificationSelectedItems:any = [];
  notificationList:any[] = [];
  notificationDropdownSettings:any = {};
  isLoadingNotifications = true;

  private notificationFilterChange = new Subject<string>();

  modalRef: BsModalRef;
  @ViewChild('templateref', { static: true }) template: TemplateRef<any>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private location: Location,
    private datePipe: DatePipe,
    private i18nService: I18NService,
    private modalService: BsModalService,
    private incidenceService: IncidenceService,
    private sergasDeviceService: SergasDeviceService,
    private sergasDeviceValuelistService: SergasDeviceValuelistService,
    private displayNotificationService: NotificationsService) {

    this.formFields = {
      'initDate': [null, Validators.required],
      'initDateD': [null, Validators.required],
      'endDate': [null, Validators.required],
      'endDateD': [null, Validators.required],
      'description' : [null, Validators.required],
      'sergasDevice' : [null],
      'sergasDeviceId' : [null, Validators.required],
      'selectedNotifications' : [null],
    };

    this.detailForm = fb.group(this.formFields);

    this.detailForm.get('sergasDevice').valueChanges.subscribe(selectedValue  => {
      if ( this.detailForm.get('sergasDevice').dirty ) {
        console.log('is dirty: ' + this.detailForm.get('sergasDevice').value)
        const deviceId = this.detailForm.get('sergasDevice').value.length ? this.detailForm.get('sergasDevice').value[0].sergasDeviceId : null;
        this.detailForm.get('sergasDeviceId').setValue(deviceId);
        this.detailForm.get('sergasDeviceId').markAsTouched();
        this.notificationFilterChange.next("");
      }
    })

    this.detailForm.get('endDate').valueChanges.subscribe(selectedValue  => {
      console.log('form value changed')
      console.log(selectedValue)
      if ( this.detailForm.get('endDate').dirty ) {
        console.log('is dirty: ' + this.detailForm.get('endDate').value)
        const date = this.detailForm.get('endDate').value ? this.detailForm.get('endDate') : null;
        this.detailForm.get('endDate').markAsTouched();
        this.notificationFilterChange.next("");
      }
    });

    this.detailForm.get('initDate').valueChanges.subscribe(selectedValue  => {
      console.log('form value changed')
      console.log(selectedValue)

      if ( this.detailForm.get('initDate').dirty ) {
        console.log('is dirty: ' + this.detailForm.get('initDate').value)
        const date = this.detailForm.get('initDate').value ? this.detailForm.get('initDate') : null;
        this.detailForm.get('initDate').markAsTouched();
        this.notificationFilterChange.next("");
      }
    });


    this.route.params.subscribe((params: Params) => {
      let incidenceId = params["incidenceId"];

      let devicesPromise =  this.sergasDeviceService.getPage(0,100000,"","")
        .then(page => {
          const values = page.content;
          this.sergasDevices = values;
          this.sergasDevicesMap = values.reduce(function(map, sergasDevice) {
            map[sergasDevice.sergasDeviceId] = sergasDevice;
            return map;
          }, {});
        });


      let preload = Promise.all([devicesPromise]);


      if ( incidenceId == "new" ) {
        this.isNew = true;
        let initDate = new Date();
        initDate.setHours(0,0,0,0);
        let endDate = initDate.getTime() + 24 * 60 * 60 * 1000;
        this.incidence = new Incidence(null, initDate.getTime(), endDate, null, null, null, null, null,null, null);
        this.incidence.initDateD = new Date(this.incidence.initDate);
        this.incidence.endDateD = new Date(this.incidence.endDate);
        this.updateFromValues(this.detailForm, this.incidence);
        preload.finally(() => this.isLoading = false);
      } else {
        preload.then(value => {
          this.incidenceService.get(incidenceId)
            .then(incidence => {
              this.isLoading = false;
              this.incidence = incidence;
              this.incidence.initDateD = new Date(incidence.initDate);
              this.incidence.endDateD = new Date(incidence.endDate);
              this.updateFromValues(this.detailForm, incidence);
              this.updateSelectors();
              this.notificationFilterChange.next("");
              this.detailForm.markAsPristine();
              incidence.notifications.forEach(notification => {
                notification.launchDateText = this.datePipe.transform(notification.launchDate, 'shortDate')
                  + " " + this.datePipe.transform(notification.launchDate, 'mediumTime')
              })
            })
            .catch(reason => {
              this.isLoading = false;
            })
        })
      }
    });

    this.isLoadingSergasDevices = true;
    if ( (<any>Object).values(this.sergasDeviceValuelistService.getValuelist()).length ) {
      this.deviceList = (<any>Object).values(this.sergasDeviceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.deviceMap = this.deviceList.reduce((previous:any, current:any) => {
        previous[current.sergasDeviceId] = current;
        return previous;
      }, {});
      this.dropdownList = this.deviceList;
      this.isLoadingSergasDevices = false;
    } else {
      this.sergasDeviceValuelistService.reload()
        .then( () => {
          this.deviceList = (<any>Object).values(this.sergasDeviceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.deviceMap = this.deviceList.reduce((previous:any, current:any) => {
            previous[current.sergasDeviceId] = current;
            return previous;
          }, {});
          this.dropdownList = this.deviceList;
          this.isLoadingSergasDevices = false;
        })
    }

    this.dropdownSettings = {
      singleSelection: true,
      primaryKey: 'sergasDeviceId',
      labelKey: 'deviceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectDevices"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 1,
      enableSearchFilter: true,
      classes: "form-angular2-multiselect"
    };

    this.configureNotificationDropdown();

  }

  ngAfterViewInit(): void {
    this.isLoadingNotifications = true;
    this.notificationFilterChange
      .pipe(
        debounceTime(300),
        switchMap(() => {
          console.log("loaging notifications")
          return this.loadDeviceNotifications(this.detailForm.get('sergasDeviceId').value, this.detailForm.get('initDate').value, this.detailForm.get('endDate').value)
            .catch(_ => []);
        }),
        catchError(() => {
          this.isLoadingNotifications = false;
          return observableOf([]);
        })
      )

      .subscribe(notifications => {
          notifications.forEach(notification => {
            notification.launchDateText = this.datePipe.transform(notification.launchDate, 'shortDate')
              + " " + this.datePipe.transform(notification.launchDate, 'mediumTime')
          })
          this.isLoadingNotifications = false;
          this.notificationList = notifications;
          // let previousSelected = this.notificationSelectedItems;
          this.notificationDropdownList = notifications;
          // this.notificationSelectedItems = notifications.filter(notification => previousSelected.some(n => n.notificationId == notification.notificationId))
          return notifications;
          }, err => console.log('HTTP Error', err),
      () => console.log('HTTP request completed.'));
  }

  private configureNotificationDropdown(){
    this.notificationDropdownSettings = {
      singleSelection: false,
      primaryKey: 'notificationId',
      labelKey: 'name',
      selectAllText: this.i18nService.get("selectAll"),
      unSelectAllText: this.i18nService.get("unselectAll"),
      filterSelectAllText: this.i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: this.i18nService.get("unselectAllFiltered"),
      noDataLabel: this.i18nService.get("noResults"),
      text: this.i18nService.get("selectNotifications"),
      searchPlaceholderText: this.i18nService.get("search"),
      badgeShowLimit: 20,
      enableSearchFilter: true,
      searchBy: ['name', 'launchDateText'],
      classes: "form-angular2-multiselect"
    };
  }



  private loadDeviceNotifications(sergasDeviceId, startDate, endDate) {
    this.isLoadingNotifications = true;
    this.notificationDropdownList.splice(0, this.notificationDropdownList.length);
    if ( sergasDeviceId != this.incidence.sergasDeviceId) {
      this.notificationSelectedItems = [];
      console.log("Set notificationSelectedItems to []")
    }
    return this.incidenceService.getNotifications(sergasDeviceId, startDate, endDate);
  }

  private updateFromValues(formGroup: FormGroup, record: Object){
    if ( record ) {
      (<any>Object).keys(formGroup.controls).forEach( (field:string) => {
        if (formGroup.controls[field]['controls']) {
          if ( record[field] ){
            this.updateFromValues(formGroup.controls[field] as FormGroup, record[field]);
          }
        } else {
          formGroup.controls[field].setValue(record[field]);
        }
      });
    } else {
      formGroup.reset();
    }
  }

  private updateSelectors(){
    this.selectedItems = this.deviceList.filter(value => this.incidence.sergasDeviceId == value.sergasDeviceId);
    this.notificationSelectedItems = this.incidence.notifications;
    console.log("Set notificationSelectedItems to "+ this.notificationSelectedItems)
  }

  ngOnInit(): void {
  }

  markAsSaved(){
    this.detailForm.markAsPristine();
  }

  backToList(){
    if ( !this.detailForm.dirty ) {
      this.router.navigate(['cloud/incidences']);
    } else {
      this.modalRef = this.modalService.show(this.template, { class: 'confirm-go-back' });
    }
  }

  confirmExit() {
    this.modalRef.hide();
    this.router.navigate(['cloud/incidences']);
  }

  onItemSelect(item: any) {
    this.detailForm.controls['sergasDeviceId'].setValue(item.sergasDeviceId);
    console.log(this.incidence.sergasDeviceId)
  }

  onNotificationSelect(item: any) {
    this.detailForm.controls['selectedNotifications'].setValue(this.notificationSelectedItems);
    console.log("onNotificationSelect");
  }

  onDeSelect(items: any) {
    this.detailForm.controls['sergasDeviceId'].setValue(null);
    console.log(this.incidence.sergasDeviceId)
  }

  onNotificationDeSelect(items: any) {
    this.detailForm.controls['selectedNotifications'].setValue(this.notificationSelectedItems);
    console.log("onNotificationDeSelect");
  }

  onInitDateChange(event) {
    if ( event && event.getTime() != this.detailForm.controls['initDate'].value) {
      console.log("InitDate changed " + event);
      this.detailForm.controls['initDate'].markAsDirty();
      this.detailForm.controls['initDate'].setValue(event.getTime());
    }

  }

  onEndDateChange(event) {
    if ( event && event.getTime() != this.detailForm.controls['endDate'].value) {
      console.log("EndDate changed " + event);
      this.detailForm.controls['endDate'].markAsDirty();
      this.detailForm.controls['endDate'].setValue(event.getTime());
    }

  }

  saveIncidence(){
    console.log("save");
    if (this.detailForm.valid) {
      this.saving = true;
      let incidence = {
        incidenceId: this.incidence.incidenceId,
        initDate: this.detailForm.get('initDate').value,
        endDate: this.detailForm.get('endDate').value,
        sergasDeviceId: this.detailForm.get('sergasDeviceId').value,
        description: this.detailForm.get('description').value,
        notifications: this.notificationSelectedItems,
      };
      let promise = this.isNew ? this.incidenceService.create(incidence) : this.incidenceService.update(incidence);
      promise
        .then(incidence => {
          if ( this.isNew ) {
            this.isNew = false;
            this.incidence = incidence;
            this.location.go('incidences/' + this.incidence.incidenceId)
          }
          this.markAsSaved();
          this.saving = false;
          this.displayNotificationService.success(this.i18nService.get("Saved"), this.i18nService.get("recordSuccessfullySaved"))
        })
        .catch(reason => {
          this.saving = false;
          this.displayNotificationService.error(this.i18nService.get("Error"), this.i18nService.get("errorSavingRecord"))
        })

    } else {
      (<any>Object).keys(this.detailForm.controls).forEach( (field:string) => {
        this.detailForm.controls[field].markAsTouched();
      });
    }
  }
}
